<template>
    <div class="w-full flex flex-column 
        gap-6 xl:gap-8 lg:gap-7 md:gap-7 sm:gap-6">
        <div class="w-full flex flex-column gap-2 justify-content-center text-center">
            <span class="flex text-900 font-medium text-3xl xl:text-6xl lg:text-5xl md:text-4xl justify-content-center">
                {{ content[lang].title }}
            </span>
        </div>
        <div class="flex w-full flex-column justify-content-center align-items-center m-auto" style="max-width:640px;">
            <img src="/images/svg/bill_big_icon.svg" class="max-w-10rem m-auto mb-4">
            <span class="inline-block m-auto justify-content-center align-items-center text-center text-600 text-lg line-height-2">
                {{ content[lang].text }}
            </span>
        </div>
        <div v-if="!isTelegram || !isEmail" class="flex flex-column gap-3 w-full max-w-30rem m-auto">
            <span class="flex text-600 text-md justify-content-center">{{ content[lang].titleTodo }}:</span>

            <MobMenu :items=[] :footerTxt="content[lang].footerText">
                <template v-slot:body>
                    <!--EMAIL-->
                    <div v-if="!isEmail || !isPhone" 
                        class="w-full flex flex-row px-3 py-2 border-100 border-bottom-1 cursor-pointer" style="min-height:50px" @click="toProfile()">
                        <div class="flex mr-3 align-items-center">
                            <Avatar class="text-600" size="small" icon="pi pi-envelope" shape="circle"/>
                        </div>
                        <div class="flex flex-1 justify-content-left align-items-center">
                            <span class="text-600">{{ content[lang].doEmail }}</span>
                        </div>
                        <div class="flex justify-content-right align-items-center">
                            <i class="text-blue-500 ml-2 pi pi-angle-right" />
                        </div>
                    </div>
                    <!--TG-->
                    <div v-if="!isTelegram" 
                        class="w-full flex flex-row px-3 py-2 border-100 border-bottom-1 cursor-pointer" style="min-height:50px" @click="showTgPopup()">
                        <div class="flex mr-3 align-items-center">
                            <Avatar class="text-600" size="small" icon="pi pi-telegram" shape="circle"/>
                        </div>
                        <div class="flex flex-1 justify-content-left align-items-center">
                            <span class="text-600">{{ content[lang].doLinkTelegram }}</span>
                        </div>
                        <div class="flex justify-content-right align-items-center">
                            <i class="text-blue-500 ml-2 pi pi-angle-right" />
                        </div>
                    </div>
                    <!--Verify-->
                    <!-- <div v-if="!isVerified" class="w-full flex flex-row px-3 py-2 border-100 cursor-pointer border-bottom-1" style="min-height:50px" @click="toVerify(isVerified)">
                        <div class="flex mr-3 align-items-center">
                            <Avatar class="text-600" size="small" icon="pi pi-verified" shape="circle"/>
                        </div>
                        <div class="flex flex-1 justify-content-left align-items-center">
                            <span class="text-600">{{ content[lang].doKYC }}</span>
                        </div>
                        <div class="flex justify-content-right align-items-center">
                            <i v-if="isVerified" class="text-500 ml-2 pi pi-check" />
                            <i v-else class="text-blue-500 ml-2 pi pi-angle-right" />
                        </div>
                    </div> -->
                </template>
            </MobMenu>
        </div>
        <div class="flex flex-column gap-3 w-full max-w-30rem m-auto">
            <Button :label="content[lang].btn" @click="toShowRules()" class="border-round-xl" size="large" :disabled="!isTelegram || !isEmail"/>
        </div>

        <div class="flex w-full flex-column faqStepsCom m-auto" style="max-width:640px;">
            <span class="flex text-700 align-items-center text-center font-medium mb-4 xl:mb-6 justify-content-center
                text-xl xl:text-4xl lg:text-5xl md:text-4xl">
                {{ content[lang].faq }}
            </span>
            <FaqShortList v-if="tabs" :tabs="tabs" :count="4" />
        </div>
    </div>

    <Dialog v-model:visible="showRules" :header="content[lang].agree_title" blockScroll modal
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { width: '100%', height: '100%' } : { width: '900px' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: '500px' }"
        class=" mx-2">
        <div class="w-full">
           <Rules />
        </div>
        <template #footer>
            <span class="w-full flex flex-column">
                <div class="w-full flex flex-row gap-2 justify-content-start align-items-center py-2">
                    <Checkbox v-model="checked" :binary="true" class="flex" />
                    <span class="flex" @click="checked=!checked">{{ content[lang].agree }}</span>
                </div>
                <Button :label="content[lang].btnAccept" icon="pi pi-check" @click="be()" 
                    :loading="loading" :disabled="loading || (!checked || !isTelegram)"
                    class="flex border-round-xl w-full" />
                    <!-- <Button :label="content[lang].btnAccept" icon="pi pi-check" @click="be()" 
                    :loading="loading" :disabled="!checked"
                    class="flex border-round-xl w-full" /> -->
            </span>
        </template>
    </Dialog>

    <!--TG-->
    <Dialog class="w-full surface-100" modal 
        v-model:visible="popupTg" 
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : 'max-w-30rem'">

        <template #header>
            <span class="text-lg font-medium">{{ content[lang].doLinkTelegram }}</span>
        </template>

        <div class="flex h-full relative">
            <BindTgButton username="telegram.username" id="telegram.id" photo_url="telegram.photo_url"/>
        </div>
               
    </Dialog>

    <!--PROFILE-->
    <Dialog class="w-full surface-100" modal 
        v-model:visible="popupProfile" 
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : 'max-w-30rem'">

        <template #header>
            <span class="text-lg font-medium">{{ content[lang].doEmail }}</span>
        </template>

        <div class="flex h-full relative">
            <Profile />
        </div>
               
    </Dialog>

</template>

<script>
import Connect      from '@/assets/js/Connect'
import Helper       from '@/assets/js/Helper'
import MobMenu      from '@/components/sides/menu/MobMenu.vue'
import FaqShortList from '@/components/widgets/FaqList.vue'
import Rules        from '@/components/personal/vcard/Rules.vue'
import BindTgButton from    '@/components/widgets/BindTgButton.vue' 
import Profile from         '@/components/personal/profile/Index.vue' 
import Event        from '@/assets/js/Event.js'

export default {
    data() {
        return {
            activeIndex: 0,
            showRules: false,
            checked: false,
            loading: false,
            popupTg: false,
            popupProfile: false,
            content: {
                ru: {
                    title: 'Виртуальные карты',
                    subtitle: '* без KYC и верификаций',
                    text: 'Выпустите витруальную карту в нашем приложении, пополните рублями или USDT. Оплачивайте покупки в интернете или оффлайн в магазинах.',
                    text2: '*Для начала работы с сервисом вам необходимо пройти верификацию. Это подтверждение вашей личности и контактных данных. Мы обязательно проверим их, чтобы обеспечить безопасность ваших средств и данных.',
                    titleTodo: 'Требуется выполнить действия',
                    footerText: 'Для выпуска карты потребуется Email и номер телефона. Для уведомлений и связи привяжите Telegram',
                    linkEmail: 'Для выпуска карты и привязки к ApplePay',
                    doLinkTelegram: 'Привязать Telegram',
                    doEmail: 'Привязать Email и телефон',
                    doKYC: 'Пройти верификацию',
                    btn: 'Подключить',
                    faq: 'Вопрос-ответ',
                    btnAccept: 'Принять условия',
                    agree: 'Я согласен с условиями',
                    agree_title: 'Условия использования',
                    success: 'Успешно',
                    successText: 'Вы успешно подключились к программе',
                    error: 'Ошибка',
                    errorText: 'Произошла ошибка при подключении к программе'
				},
				en: {
                    title: 'Virtual cards',
                    subtitle: 'Get a card for purchases without KYC and verification',
                    text: 'Issue a virtual card in our application, top it up with rubles, any other currency or USDT. Pay for purchases online or offline in stores.',
                    text2: '*To start working with the service, you need to pass verification. This is confirmation of your identity and contact details. We will definitely check them to ensure the security of your funds and data.',
                    titleTodo: 'You need to do the following',
                    footerText: 'To issue a card, you will need an Email and a phone number. To receive notifications and contact us, link Telegram',
                    linkEmail: 'To issue a card and link to ApplePay',
                    doLinkTelegram: 'Link Telegram',
                    doEmail: 'Link Email and phone',
                    doKYC: 'Pass verification',
                    btn: 'Connect',
                    faq: 'FAQ',
                    btnAccept: 'Accept terms',
                    agree: 'I agree to the terms',
                    agree_title: 'Terms of service',
                    success: 'Success',
                    successText: 'You have successfully connected to the program',
                    error: 'Error',
                    errorText: 'An error occurred while connecting to the program'
				}
			},
            tabs: [
                {
                    ru: {
                        title: 'Привяжите Telegram и Email',
                        content: 'В Телеграм приходят важные уведомления, а Email нужен для выпуска карты. Привяжите их к своему аккаунту, чтобы получать уведомления и важную информацию'
                    },
                    en: {
                        title: 'Link Telegram and Email',
                        content: 'Telegram receives important notifications, and Email is needed to issue a card. Link them to your account to receive notifications and important information'
                    }
                },
                {
                    ru: {
                        title: 'Выпустите виртуальную карту',
                        content: 'Прямо в личном кабинете вы можете выпустить виртуальную карту. Вам будут доступны все данные для оплаты в интернете'
                    },
                    en: {
                        title: 'Issue a virtual card',
                        content: 'Right in your personal account, you can issue a virtual card. You will have all the data available for payment on the Internet'
                    }
                },
                {
                    ru: {
                        title: 'Оплачивайте Netflix, Spotify и другие сервисы',
                        content: 'Пополняйте карту и оплачивайте любые интернет-сервисы, такие как Netflix, Spotify, Google Play и другие'
                    },
                    en: {
                        title: 'Pay for Netflix, Spotify and other services',
                        content: 'Top up your card and pay for any online services such as Netflix, Spotify, Google Play and others'
                    }
                },
                {
                    ru: {
                        title: 'Смотрите расходы в личном кабинете',
                        content: 'Все успешные переводы клиентов будут отображаться в вашем личном кабинете. Вы сможете видеть все платежи и их статусы'
                    },
                    en: {
                        title: 'Watch expenses in your personal account',
                        content: 'All successful customer transfers will be displayed in your personal account. You will be able to see all payments and their statuses'
                    }
                }
            ]
        }
    },
    components: {
        MobMenu,
        FaqShortList,
        Rules,
        BindTgButton,
        Profile
    },
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        screenSize() { return this.$store.getters.StateScreenSize },
        isLoggedIn: function () { return this.$store.getters.isAuthenticated },
        isDarkTheme() { return this.$store.getters.StateDarkTheme },
        isTelegram: function () { return this.$store.getters.StateTelegramUsername },
        isEmail: function () { return this.$store.getters.StateUserEmail },
        isVerified: function () { return this.$store.getters.StateVerified },
        isPhone: function () { return this.$store.getters.StateUserPhone },
    },
    methods: {
        showMess(severity, summary, detail) {
            this.$toast.add({severity: severity, summary: summary, detail: detail, life: 3000});
        },
        toVerify(isVerified){
            if(isVerified) return
            this.$router.push({path: '/verify/process/'})
        },
        toProfile(){
            if(this.isEmail) return 
            this.popupProfile = true
        },
        showTgPopup() {
            if(this.isTelegram) return
            this.popupTg = true
        },
        toShowRules(){
            this.showRules = !this.showRules
            try { this.event.send('vcardJoin') } catch {}
        },
        async be() {
            try { this.event.send('vcardConfirm') } catch {}
            this.loading = true
            try {
                const add = await this.connect.GetVCardProgram().then(res=>res).catch(err=>err)
                if(add.result && add.data){
                    this.showMess('success', this.content[this.lang].success, this.content[this.lang].successText)
                    this.showRules = false
                    await this.$store.dispatch('setAddGroup', 'vcard').then(() => {}) 
                    this.event.send('vcardSuccess')
                } else {
                    if(add.errors && add.errors.length > 0){
                        this.showMess('error', this.content[this.lang].error, add.errors[0])
                    } else this.showMess('error', this.content[this.lang].error, this.content[this.lang].errorText)
                }
            } catch {
                this.showMess('error', this.content[this.lang].error, this.content[this.lang].errorText)
            }
            this.loading = false
        }
    },
    beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
        this.event = new Event(this)
    },
    mounted() {
        this.helper.SetTgAppHeadColor('gray', this.isDarkTheme)
	}
}
</script>